import { useEffect, useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ReferralSettings({ api }) {
  const [s, setS] = useState(null);
  const [form, setForm] = useState({ pct: "", reward: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/referral-settings").then(({ data }) => {
      setS(data);
      setForm({ pct: String(data.discount_pct), reward: String(data.reward_cents / 100) });
    }).catch(() => {});
  }, [api]);
  if (!s) return null;
  const save = async () => {
    const pct = parseInt(form.pct, 10);
    const reward = Math.round(parseFloat(form.reward) * 100);
    if (!(pct >= 1 && pct <= 90) || !(reward >= 0 && reward <= 100000)) {
      toast.error("Discount must be 1–90% and credit $0–$1000.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.put("/admin/referral-settings", { discount_pct: pct, reward_cents: reward });
      setS((x) => ({ ...x, ...data }));
      toast.success("Referral settings saved");
    } catch {
      toast.error("Could not save settings.");
    } finally {
      setBusy(false);
    }
  };
  const input = "h-11 w-24 px-3 bg-[#141414] border border-[#262626] text-white text-sm";
  return (
    <section className="brutal-border p-4 sm:p-5 mb-8" data-testid="referral-settings">
      <div className="font-mono-label text-[10px] text-muted-foreground inline-flex items-center gap-1.5 mb-3"><Gift size={12} className="text-[#FFD600]" /> REFERRAL PROGRAM · {s.total} PAID REFERRAL{s.total === 1 ? "" : "S"}</div>
      <div className="flex flex-wrap items-end gap-4">
        <label className="text-xs text-muted-foreground">New client discount (%)
          <input type="number" min={1} max={90} value={form.pct} onChange={(e) => setForm({ ...form, pct: e.target.value })} className={`block mt-1 ${input}`} data-testid="referral-settings-pct" />
        </label>
        <label className="text-xs text-muted-foreground">Referrer credit ($)
          <input type="number" min={0} step="1" value={form.reward} onChange={(e) => setForm({ ...form, reward: e.target.value })} className={`block mt-1 ${input}`} data-testid="referral-settings-reward" />
        </label>
        <button onClick={save} disabled={busy} data-testid="referral-settings-save" className="h-11 px-4 cta-primary font-mono-label text-[11px] inline-flex items-center gap-2 disabled:opacity-60">
          {busy && <Loader2 size={13} className="animate-spin" />} Save
        </button>
      </div>
      <p className="text-[11px] text-muted-foreground mt-2">The discount applies to every renewal of the 3-month, 6-month and annual plans. Changes apply to new checkouts only.</p>
    </section>
  );
}
